import React from 'react'
import {
    Alert,
    Box,
    FormControlLabel,
    Paper,
    Radio,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExport } from '@fortawesome/pro-duotone-svg-icons/faFileExport'
import DefaultSearchbar from '@/shared/composed-ui/search/DefaultSearchbar'
import { StyledButton } from '@/shared/ui/buttons'
import { KedocxTableProps } from '../types'
import { StyledTable } from '@/shared/ui/tables'
import {
    selectionControlLabelProps,
    selectionControlSx,
} from '@/shared/ui/input'

export default function KedocxTable(props: KedocxTableProps) {
    const {
        kedo,
        kedocx,
        selected,
        errorkedocx,
        fileType,
        onExport,
        searchValue,
        handleFilterChange,
        onSearchKedocx,
        onReset,
        onChangeKedocx,
    } = props

    return (
        <div className="table-responsive">
            <br />
            <h5>{kedo.t('Select Kedocx')}</h5>
            <Box sx={{ mb: 2 }}>
                <DefaultSearchbar
                    kedo={kedo}
                    searchName={searchValue}
                    handleChange={handleFilterChange}
                    onSearch={onSearchKedocx}
                    onReset={onReset}
                />
            </Box>

            <TableContainer component={Paper}>
                <StyledTable size="small" striped hover>
                    <TableHead>
                        <TableRow
                            sx={{
                                '& .MuiTableCell-head': {
                                    textAlign: 'left',
                                    fontWeight: 'bold',
                                },
                            }}
                        >
                            <TableCell style={{ width: '5%' }}>
                                &nbsp;
                            </TableCell>
                            <TableCell style={{ width: '5%' }}>#</TableCell>
                            <TableCell>{kedo.t('Name')}</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {kedocx && kedocx.length > 0 ? (
                            kedocx.map((item) => (
                                <TableRow key={item.id}>
                                    <TableCell>
                                        <FormControlLabel
                                            {...selectionControlLabelProps}
                                            sx={{
                                                ...selectionControlLabelProps.sx,
                                                width: '100%',
                                                mr: 0,
                                            }}
                                            aria-label={item.name}
                                            control={
                                                <Radio
                                                    size="small"
                                                    value={String(item.id)}
                                                    checked={
                                                        selected ===
                                                        String(item.id)
                                                    }
                                                    onChange={onChangeKedocx}
                                                    sx={(theme) =>
                                                        selectionControlSx(
                                                            theme
                                                        )
                                                    }
                                                />
                                            }
                                            label=""
                                        />
                                    </TableCell>
                                    <TableCell>{item.id}</TableCell>
                                    <TableCell>{item.name}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <Alert severity="warning">
                                        {kedo.t('No files found')}
                                    </Alert>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </StyledTable>
            </TableContainer>

            {errorkedocx && (
                <div>
                    <Alert severity="error">{errorkedocx}</Alert>
                </div>
            )}

            <br />

            {fileType && (
                <StyledButton
                    onClick={onExport}
                    disabled={!selected}
                    sx={{ '& svg': { mr: 1 } }}
                >
                    <FontAwesomeIcon icon={faFileExport} />
                    {kedo.t('Export')}
                </StyledButton>
            )}
        </div>
    )
}
